import angular from 'angular';
import '../core.module';

export const API_BASE_URL = process.env.API_BASE_URL;

angular.module('app.core').constant('API_BASE_URL', API_BASE_URL);

export const APP_VERSION = {
  label: process.env.APP_VERSION || 'dev',
  builtAt: process.env.APP_BUILT_AT || ''
};

angular.module('app.core').constant('APP_VERSION', APP_VERSION);
